export enum DepositApiUrls {
  Deposits = "/v1/Deposits",
  DepositTransactions = "/v1/Deposits/:id/Transactions",
  DepositSchedule = "/v1/Deposits/:id/Schedule",
  DepositStatement = "/v1/Deposits/:id/Statements",
  DepositStatementExport = "/v1/Deposits/:id/Statements/Export",
}
